import { Box, Button, styled, Typography, useTheme } from '@mui/material'
import { color } from 'framer-motion'
import React from 'react'
interface SelectableOptionItemProps {
  label: string
  isSelected: boolean
  isDisabled?: boolean
  onClick: () => void
}
export default function SelectSize({
  label,
  isSelected,
  isDisabled = false,
  onClick,
}: SelectableOptionItemProps) {
  const theme = useTheme()
  return (
    <Box sx={{ position: 'relative' }}>
      {isSelected && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            border: `2px solid ${theme.palette.primary.main}`,
            backgroundColor: theme.palette.primary.main,
            borderRadius: '8px',
            pointerEvents: 'none',
            zIndex: 0,
            transition: 'all 0.2s ease-in-out',
          }}
        />
      )}
      <SizeButton
        isSelected={isSelected}
        isAvailable={!isDisabled}
        onClick={onClick}
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Typography sx={{ color: 'inherit', fontSize: 'inherit' }} fontWeight={600}>
          {label}
        </Typography>
      </SizeButton>
    </Box>
  )
}
const SizeButton = styled(Button, {
  shouldForwardProp: (prop) => !['isSelected', 'isAvailable'].includes(prop as string),
})<{
  isSelected?: boolean
  isAvailable?: boolean
}>(({ theme, isSelected, isAvailable }) => ({
  borderRadius: '4px',
  backgroundColor: !isAvailable ? '#F0F0F0' : isSelected ? theme.palette.primary.main : '#fff',
  color: !isAvailable ? '#BBBBBA' : isSelected ? 'white' : 'black',
  border: '1px solid',
  borderColor: !isAvailable ? '#F0F0F0' : isSelected ? theme.palette.primary.main : '#BBBBBA',
  pointerEvents: isAvailable ? 'auto' : 'none',
  opacity: isAvailable ? 1 : 0.5,
  transition: 'all 0.2s',
  fontSize: '0.875rem',
  cursor: isAvailable ? 'pointer' : 'not-allowed',
  minWidth: 0,
  width: '36px',
  height: '36px',
  '&:hover': {
    backgroundColor: isAvailable
      ? isSelected
        ? theme.palette.primary.main
        : theme.palette.primary.main
      : '#F0F0F0',
    color: !isAvailable ? '#BBBBBA' : 'white',
    borderColor: isAvailable
      ? isSelected
        ? theme.palette.primary.main
        : theme.palette.primary.main
      : '#F0F0F0',
  },
  [theme.breakpoints.down('md')]: {
    padding: '0px',
    width: '36px',
    height: '36px',
  },
}))
